import $ from 'jquery';
import { isEmpty } from '@invia/web-library/helpers/utils';
import Tabs from '../../helpers/tabs';

export const init = ($target) => {
	// Taby DZ + Taby pro login na DZ + moje.invia
	$('#htabs-box, .htabs-box-login').each(function (index) {
		const $this = $(this);
		const thisNav = $this.find('.htabs-nav');

		if (isEmpty(thisNav.data('sk-tabs'))) {
			const tabs = new Tabs(
				$this.find('.htabs-nav p'), {
					current: $this.find('.htabs-nav .active').index() != -1 ? $this.find('.htabs-nav .active').index() : 0,
					history: true,
				},
			).init();

			window.addEventListener('hashchange', function (e) {
				tabs.hash();
			});

			thisNav.data('sk-tabs', tabs);
		}
	});
};
